import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, Typography, message, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/images/ldc_logo_new.png";
import axios from 'axios';
import { Config } from "./Common/Config";


const { Title } = Typography;
const { Header, Footer } = Layout;
const Login = () => {
  const [loginStep, setloginStep] = useState(1)
  const [storeLogingData, setstoreLogingData] = useState(null)
  const navigate = useNavigate();


  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate('/dashboard')
    }
  }, [])

  // console.log('Config.urlLogin:::', Config.urlLogin)

  const [messageApi, contextHolder] = message.useMessage();
  const onFinish = async (values) => {
    try {
      // const response = await axios.post(`${Config.urlLogin}/api/v1/login`, {
      const response = await axios.post(`${Config.urlLogin}/api/v1/login`, {
        email: values.email,
        password: values.password
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      // console.log('Login Successful:', response);
      messageApi.success({
        type: 'succes',
        content: 'Logged in successfully',
      });

      setstoreLogingData(response.data.data)
      localStorage.setItem('token', response.data.data.token)
      localStorage.setItem('userData', JSON.stringify(response.data.data))
      // navigate('/dashboard')
      // return
      if (response?.data?.data && response.data.data?.is_2fa_enabled && response.data.data?.is_2fa_enabled == 1) {
        setloginStep(2)
        sendOTP(response?.data?.data)
      } else {
        localStorage.setItem('token', response.data.data.token)
        localStorage.setItem('userData', JSON.stringify(response.data.data))
        navigate('/dashboard')
      }

    } catch (error) {
      console.log('Login Failed:', error.response?.data || error?.message);
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || 'Something Went wrong',
      });
    }

  };
  const sendOTP = async (data) => {
    if (!data?.phone_number) {
      messageApi.error({
        type: 'error',
        content: 'phone number missing',
      });
      return
    }
    try {
      let payload = {
        "phone_number": data.phone_number,//447920115473 //447832738093
        "type": "login via phone number"
      }
      // let url = `${Config.urlLogin}/api/v1/sms/otp/sent`
      let url = `${Config.urlLogin}/api/v1/sms/otp/sent`
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      // console.log('response:::', response)
      if (response.data.status) {

        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      } else {
        setloginStep(1)
        localStorage.removeItem('token')
        localStorage.removeItem('userData')
        localStorage.clear()
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      }
    } catch (error) {
      messageApi.error({
        type: 'error',
        content: error?.response?.data?.message || 'Error sending OTP',
      })
    }
  }
  const handleOtpVerification = async (values) => {
    // console.log('::::::handleOtpVerification:::::values::', values)
    if (!storeLogingData.phone_number && !values.otp) {
      messageApi.error({
        type: 'error',
        content: 'Error sending OTP',
      })
      return
    }
    try {
      let payload = {
        "phone_number": storeLogingData.phone_number,
        "otp": values.otp
      }
      // console.log('payload :::', payload)
      let url = `${Config.urlLogin}/api/admin/v1/sms/auth/otp/verify`
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      // console.log('response:::', response)
      if (response.data.status) {
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })

        navigate('/dashboard')
      } else {
        setloginStep(1)
        localStorage.removeItem('token')
        localStorage.removeItem('userData')
        localStorage.clear()
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
      }
    } catch (error) {
      setloginStep(1)
      localStorage.removeItem('token')
      localStorage.removeItem('userData')
      localStorage.clear()
      messageApi.error({
        type: 'error',
        content: error?.response?.data?.message || 'Error sending OTP',
      })
    }
  }
  const handleForgetPassword = async (values) => {
    // console.log('::::::handleOtpVerification:::::values::', values)
    // return
    if (!values.email) {
      messageApi.error({
        type: 'error',
        content: 'Enter email first',
      })
      return
    }
    try {
      let payload = {
        "email": values.email
      }
      // console.log('payload :::', payload)
      let url = `${Config.urlLogin}/api/v1/send-reset-password-email`
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      // console.log('response:::', response)
      if (response.data.status) {
        messageApi.success({
          type: 'success',
          content: response.data.message,
        })
        setloginStep(1)
      }
    } catch (error) {
      console.log('error handleForgetPassword:::', error)
      localStorage.removeItem('token')
      localStorage.removeItem('userData')
      localStorage.clear()
      messageApi.error({
        type: 'error',
        content: error?.response?.data?.message,
      })
    }
  }

  return (
    <div>
      <Header style={{ background: "#008385", padding: "30px 20px", justifyContent: "center", display: "flex", marginBottom: "40px", alignItems: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <img src={logo} alt="Logo" style={{ height: "40px" }} />
      </Header>
      <div className="flex justify-center items-center min-h-screen bg-gray-50" style={{ display: 'flex', justifyContent: 'center', }}>
        {contextHolder}
        {loginStep == 1 && <Card
          style={{
            width: "600px", // Adjust card width here
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",

          }}
        >
          {/* Header */}
          <div
            className="text-white text-center py-3"
            style={{
              backgroundColor: "#008385",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              margin: "-20px -20px 20px -20px", // Ensures header aligns with card edges
              padding: "15px",
            }}
          >
            <Title level={4} className="m-0 text-white" style={{ color: "#fff" }}>
              Login
            </Title>
          </div>

          <Form name="login" onFinish={onFinish} layout="vertical">
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email!" }]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter your password!" }]}
              style={{ marginBottom: 10 }}
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>
            <div style={{ textAlign: "right", marginBottom: 10, padding: 0 }}>
              <a style={{ backgroundColor: "#fff", borderColor: "#fff" }} onClick={() => setloginStep(3)}>
                Forgot Password
              </a>
            </div>
            <Form.Item>
              <Button color="#008385" type="primary" htmlType="submit" block className="bg-purple-600" style={{ backgroundColor: "#008385", borderColor: "#008385" }}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </Card>}
        {loginStep == 2 && <Card
          style={{
            width: "600px", // Adjust card width here
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",

          }}
        >
          {/* Header */}
          <div
            className="text-white text-center py-3"
            style={{
              backgroundColor: "#008385",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              margin: "-20px -20px 20px -20px", // Ensures header aligns with card edges
              padding: "15px",
            }}
          >
            <Title level={4} className="m-0 text-white" style={{ color: "#fff" }}>
              Phone Number Verification
            </Title>
          </div>

          {/* Form */}
          <Form name="otp" onFinish={handleOtpVerification} layout="vertical">
            <Title level={4} className="m-0 text-black" style={{ color: "#000", textAlign: 'left' }}>

            </Title>
            <Form.Item
              label="Enter OTP"
              name="otp"
              rules={[{ required: true, message: "Please enter your otp!" }]}
            >
              <Input placeholder="Enter your otp" />
            </Form.Item>
            <Form.Item>
              <Button color="#008385" type="primary" htmlType="submit" block className="bg-purple-600" style={{ backgroundColor: "#008385", borderColor: "#008385" }}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </Card>}
        {loginStep == 3 && <Card
          style={{
            width: "600px", // Adjust card width here
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",

          }}
        >
          {/* Header */}
          <div
            className="text-white text-center py-3"
            style={{
              backgroundColor: "#008385",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              margin: "-20px -20px 20px -20px", // Ensures header aligns with card edges
              padding: "15px",
            }}
          >
            <Title level={4} className="m-0 text-white" style={{ color: "#fff" }}>
              Forgot Password
            </Title>
          </div>

          {/* Form */}
          <Form name="forgetPassword" onFinish={handleForgetPassword} layout="vertical">
            <Title level={4} className="m-0 text-black" style={{ color: "#000", textAlign: 'left' }}>

            </Title>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>
            <Form.Item>
              <Button color="#008385" type="primary" htmlType="submit" block className="bg-purple-600" style={{ backgroundColor: "#008385", borderColor: "#008385" , marginBottom : 0 }}>
                Reset Password
              </Button>
            </Form.Item>
             <div style={{ textAlign: "center", marginBottom: 0, padding: 0 ,}}>
              <a style={{ backgroundColor: "#fff", borderColor: "#fff" }} onClick={() => setloginStep(1)}>
                Back to Login
              </a>
            </div>
          </Form>
        </Card>}
      </div>
      <Footer style={{
        textAlign: "center", marginTop: "3%", color: "#ffffff", position: "fixed",
        bottom: "0",
        width: "100%", background: "#008385", padding: "10px 0", boxShadow: "0 -2px 8px rgba(0,0,0,0.1)"
      }}>
        © {new Date().getFullYear()} London Doctor Clinics. All rights reserved.
      </Footer>
    </div>
  );
};

export default Login;
